import { render, staticRenderFns } from "./SelectExchangeProduct.vue?vue&type=template&id=2b32f3dc&scoped=true&"
import script from "./SelectExchangeProduct.vue?vue&type=script&lang=js&"
export * from "./SelectExchangeProduct.vue?vue&type=script&lang=js&"
import style0 from "./SelectExchangeProduct.vue?vue&type=style&index=0&id=2b32f3dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32f3dc",
  null
  
)

export default component.exports